"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const URLs_1 = require("../utility/URLs");
const react_bootstrap_1 = require("react-bootstrap");
const react_router_dom_1 = require("react-router-dom");
const Paginator_1 = __importDefault(require("../../commonFiles/Paginator"));
const Filters_1 = require("../components/Filters");
function CategoriesIndex(props) {
    var _a;
    const [categoriesPag, setcategoriesPag] = react_1.default.useState();
    function fetchCategories(params = null) {
        return URLs_1.Api.fetchCategories(Object.assign(Object.assign({}, (0, Filters_1.getPaginationParams)(categoriesPag)), params));
    }
    react_1.default.useEffect(() => {
        fetchCategories();
    }, []);
    function deleteCategory(id) {
        (0, URLs_1.ApiCallHandler)(() => URLs_1.Api.deleteCategory(id), null, 'CategorysIndex deleteCategory', true);
    }
    return react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: 'd-flex align-items-center fs-4 ' },
            react_1.default.createElement("i", { className: "bi bi-tag" }),
            react_1.default.createElement("div", { className: 'mx-2' }, "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u0642\u0627\u0644\u0627\u062A")),
        react_1.default.createElement("div", { className: 'bg-white rounded shadow m-3 p-4' },
            react_1.default.createElement("div", { className: 'd-flex' },
                react_1.default.createElement(Filters_1.TextFilter, { apiCall: fetchCategories, property: 'name', label: 'اسم التصنيف', useState: [categoriesPag, setcategoriesPag] })),
            react_1.default.createElement(react_bootstrap_1.Table, { striped: true, bordered: true, hover: true },
                react_1.default.createElement("thead", null,
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement("th", null, "#"),
                        react_1.default.createElement("th", null, "\u0627\u0644\u0639\u0646\u0648\u0627\u0646"),
                        react_1.default.createElement("th", null))),
                react_1.default.createElement("tbody", null, (_a = categoriesPag === null || categoriesPag === void 0 ? void 0 : categoriesPag.data) === null || _a === void 0 ? void 0 : _a.map((category, index) => (react_1.default.createElement("tr", { key: index },
                    react_1.default.createElement("td", null,
                        " ",
                        react_1.default.createElement(react_router_dom_1.Link, { to: URLs_1.Routes.categoryShow(category.id) },
                            " ",
                            category.id,
                            "  "),
                        " "),
                    react_1.default.createElement("td", null, category.name),
                    react_1.default.createElement("td", { onClick: () => {
                            if (confirm('هل انت متاكد من الحدف؟'))
                                deleteCategory(category.id);
                        } }, "\u062D\u062F\u0641")))))),
            react_1.default.createElement(Paginator_1.default, { page_size: 500, log: 'FETCH categoriesPag', apiCall: fetchCategories, useState: [categoriesPag, setcategoriesPag] })));
}
exports.default = CategoriesIndex;
